import React from "react"
import { FormattedMessage } from "react-intl"


import Content from "../pages/profile/posts/view/content/Content"
import ResponseTools from "./ResponseTools"

import { useIntl } from "react-intl"

// ensure the composer isn't loaded until we need it by loading via universal!
import universal from "react-universal-component"
import ConclusionContentCard from "../pages/profile/posts/view/PostComplete/ConclusionCard"
import { ReactFC } from "types"
import { CommentPost } from "posts/posts.types"
// import { getPersonName } from "components/PersonName"

import MemberProfileLink from "profile/MemberProfileLink"

import { ResponseWrapper } from "../posts/ResponseWrapper"
import { getDirection } from "core/useDirectionality"
// import { NumberingAndAuthor, Numbering, AuthorAndMeta } from "lib-core"
import { InlineEditor } from "./InlineEditor"
import styled from "styled-components"
// import { usePostContext } from "posts/PostContext"
// import { useResponsesContext } from "./ResponsesContext"
import createLogger from 'debug'
import { FlaggedMessage } from "posts/FlaggedMessage"
import {
  useResponsesContext, usePostContext,
  ResponsesProps, ResponseOuterDiv, ResponsesRoot,
  ResponseTitle, ResponseHeader,
  NumberingAndAuthor, Numbering, AuthorAndMeta,
  getPersonName, useOpenResponse, ResponseTagsPicker
} from "lib-core"
import { ResponseProps } from "./ResponseProps"

// to enable localStorage.debug = 'info:*'
const info = createLogger('info:ui')



export const InlineArticleComposer = universal((props) =>
  import("post-responses/InlineArticleComposer")
)

export const Conclusion = ({ content, title, language }) => {
  const intl = useIntl()
  function renderConclusion(str) {
    try {
      return (
        <ConclusionContentCard
          dir={getDirection(language)}
          post={JSON.parse(str)}
          title={title}
        />
      )
    } catch {
      return <h1>{str}</h1>
    }
  }
  return (
    <div style={{ color: "teal", borderBottom: "1px solid teal" }}>
      {renderConclusion(content)}
    </div>
  )
}

const BodyWrapper = styled.div`
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  padding: 5px;
`

const ResponseContent = () => {
  const { post: response } = usePostContext()
  const { expanded } = useResponsesContext()
  if (!expanded) {
    return null
  }
  return (
    <BodyWrapper>
      <FlaggedMessage />
      <MessageContent response={response} />
    </BodyWrapper>
  )
}

const ResponseCountWrapper = styled.span`
  align-self: flex-end;
  color: #666;
  font-size: 0.75em;
  padding: 0.5em;
`

export const UserResponse: ReactFC<ResponseProps> = ({ response, showResponseCount }) => {
  info("response: %o", response)
  const responseCount = response.responses?.length
  return (
    <ResponseOuterDiv>
      <ResponseWrapper response={response}>
        <ResponseHeader>
          <NumberingAndAuthor>
            <Numbering />
            <AuthorAndMeta
              author={response.author}
              created={response.created}
              readTime={response.readTime}
            />
          </NumberingAndAuthor>

          <ResponseTitle />

          <ResponseTools />
        </ResponseHeader>
        <ResponseContent />
        <ResponseTagsPicker response={response} />
        <InlineEditor />
        {showResponseCount && responseCount ? (
          <ResponseCountWrapper>
            <FormattedMessage id="post.n_responses" values={{ responseCount }} />
          </ResponseCountWrapper>
        ) : null}
      </ResponseWrapper>
    </ResponseOuterDiv>
  )
}

const RemovedWrapper = styled.span`
  color: #999;
`

const MessageContent: ReactFC<{ response: CommentPost }> = ({ response }) => {
  if (!response.unpublished) {
    return (
      <Content
        data={response.content}
        dir={getDirection(response.language)}
      />
    )
  }

  if (!response.unpublishedBy) {
    return (
      <RemovedWrapper>
        <FormattedMessage id="post.response_removed" />
      </RemovedWrapper>
    )
  }

  return (
    <RemovedWrapper>
      <FormattedMessage id="post.response_removed_by" />
      <span>&nbsp;</span>
      <span><MemberProfileLink user={response.unpublishedBy}>{getPersonName(response.unpublishedBy)}</MemberProfileLink></span>
    </RemovedWrapper>
  )
}

const ResponsesInner: ReactFC<ResponsesProps> = (props) => {
  useOpenResponse()
  return (
    <ResponsesRoot {...props} />
  )
}


const Responses: ReactFC<ResponsesProps> = (props) => {
  const { order } = props
  if (!order || !order.length) {
    return null
  }

  return (
    <ResponsesInner {...props} />
  )
}

export default Responses
